import YBlockBox from "./YBlockBox/index.vue";
import YSpacer from "./YSpacer.vue"
import YIcon from "./YIcon/index.vue";
import BtnChangeGroup from "./BtnChangeGroup/index.vue";

export default {
  install (Vue) {
    Vue.component(YBlockBox.name, YBlockBox)
    Vue.component(YSpacer.name, YSpacer)
    Vue.component(YIcon.name, YIcon)
    Vue.component(BtnChangeGroup.name, BtnChangeGroup)
  }
}



// WEBPACK FOOTER //
// ./src/components/YUI/index.js